import React, { useEffect, useState } from 'react';
import api from '../lib/api';

const OPTIONS = [
  { key: null, label: 'Toate' },
  { key: 'barbati', label: 'Bărbați' },
  { key: 'femei', label: 'Femei' },
];

// Filtru Bărbați / Femei pentru modă; apare doar dacă categoria are articole cu gen
export const GenderFilter = ({ category, value, onChange }) => {
  const [counts, setCounts] = useState({ barbati: 0, femei: 0 });

  useEffect(() => {
    if (!category) { setCounts({ barbati: 0, femei: 0 }); return; }
    api.get('/products/filters/genders', { params: { category } })
      .then((r) => setCounts(r.data || { barbati: 0, femei: 0 }))
      .catch(() => setCounts({ barbati: 0, femei: 0 }));
  }, [category]);

  if (!counts.barbati && !counts.femei && !value) return null;

  return (
    <div className="mb-4 flex flex-wrap gap-2" data-testid="gender-filter">
      {OPTIONS.map((o) => {
        const active = (value || null) === o.key;
        return (
          <button key={o.label} type="button" onClick={() => onChange(o.key)}
                  data-testid={`gender-filter-${o.key || 'toate'}`}
                  className={`rounded-full border-2 px-5 py-2 text-sm font-semibold transition-colors ${active ? 'border-green-600 bg-green-600 text-white' : 'border-gray-200 bg-white text-gray-700 hover:border-green-400'}`}>
            {o.label}
            {o.key && <span className={`ml-1.5 text-xs ${active ? 'text-green-100' : 'text-gray-400'}`}>{counts[o.key].toLocaleString('ro-RO')}</span>}
          </button>
        );
      })}
    </div>
  );
};
